import { ChevronRight } from "lucide-react";
import { Link } from "react-router-dom";

const PageHero = ({ eyebrow, title, description, breadcrumbs = [], image }) => {
  return (
    <section className="relative pt-[140px] md:pt-[170px] pb-14 md:pb-20 overflow-hidden bg-[hsl(var(--rc-paper))]">
      <div
        aria-hidden
        className="absolute inset-0 -z-10 bg-[radial-gradient(ellipse_at_top_left,_rgba(91,58,122,0.10),_transparent_55%),radial-gradient(ellipse_at_bottom_right,_rgba(200,164,101,0.08),_transparent_50%)]"
      />
      <div className="max-w-7xl mx-auto px-5 md:px-8 relative">
        {breadcrumbs.length > 0 && (
          <nav aria-label="Breadcrumb" className="flex items-center gap-1.5 text-[12.5px] text-[hsl(var(--muted-foreground))]">
            <Link to="/" className="hover:text-[hsl(var(--rc-deep))] transition-colors">
              Home
            </Link>
            {breadcrumbs.map((b, i) => (
              <span key={b.href || i} className="flex items-center gap-1.5">
                <ChevronRight className="w-3 h-3" />
                {b.href ? (
                  <Link to={b.href} className="hover:text-[hsl(var(--rc-deep))] transition-colors">
                    {b.label}
                  </Link>
                ) : (
                  <span className="text-[hsl(var(--rc-charcoal))] font-medium">{b.label}</span>
                )}
              </span>
            ))}
          </nav>
        )}

        <div className={`mt-6 grid ${image ? "lg:grid-cols-12" : ""} gap-10 items-center`}>
          <div className={image ? "lg:col-span-7" : "max-w-3xl"}>
            {eyebrow && (
              <p className="text-[12px] tracking-[0.22em] uppercase text-[hsl(var(--rc-purple))] font-semibold">
                {eyebrow}
              </p>
            )}
            <h1 className="font-serif-display mt-3 text-[42px] sm:text-[52px] lg:text-[64px] leading-[1.05] font-semibold text-[hsl(var(--rc-deep))]">
              {title}
            </h1>
            {description && (
              <p className="mt-5 text-[16.5px] md:text-[17.5px] leading-[1.7] text-[hsl(var(--rc-slate))] max-w-2xl">
                {description}
              </p>
            )}
          </div>
          {image && (
            <div className="lg:col-span-5">
              <div className="relative aspect-[4/3] w-full rounded-2xl overflow-hidden shadow-[0_30px_70px_-30px_rgba(60,40,90,0.4)]">
                <img src={image} alt="" className="absolute inset-0 w-full h-full object-cover" />
              </div>
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default PageHero;
